import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import { OSSURL } from '../constant'
import NullData from './nullData'

const Item = styled.div`
  background: url(${OSSURL}/block_bg.png) no-repeat;
  height: 32%;
  background-size: 100% 100%;
  ${tw`w-1/2 flex flex-col pl-4 justify-center gap-1`}
`

const Block = function ({ data, customDsl }) {
  const [itemData, setItemData] = useState({})
  const { appId } = useParams()

  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        setItemData(res)
      })
  }, [customDsl])

  return (
    <div className="flex h-full items-center w-full flex-wrap">
      {Object.keys(itemData).length === 0 && <NullData />}
      {Object.keys(itemData).length !== 0 &&
        Object.keys(itemData).map((d, i) => {
          if (i < 6) {
            return (
              <Item key={d}>
                <div style={{ color: '#DED53C' }} className="font-bold">
                  {itemData[d]}
                </div>
                <div className="text-xs">{d}</div>
              </Item>
            )
          }
          return null
        })}
    </div>
  )
}

export default Block
